import * as XLSX from "xlsx";

const HEADERS = ["Group Name", "Site Name", "User ID", "Date", "Settlement Amount"];
const norm = (k) => String(k).toLowerCase().replace(/[^a-z]/g, "");
const ALIASES = {
  group_name: ["groupname", "group"],
  site_name: ["sitename", "site"],
  user_code: ["userid", "user", "usercode"],
  entry_date: ["date", "entrydate"],
  amount: ["settlementamount", "amount", "settlementamountinr", "settlement"],
};

const toISO = (v) => {
  if (v == null || v === "") return null;
  if (v instanceof Date) return new Date(v.getTime() - v.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const s = String(v).trim();
  let m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
  if (m) return `${m[1]}-${m[2].padStart(2, "0")}-${m[3].padStart(2, "0")}`;
  m = s.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (m) return `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
  return "invalid";
};

export const parseSheet = async (file, defaultDate) => {
  const wb = XLSX.read(await file.arrayBuffer(), { cellDates: true });
  const raw = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
  const rows = [], errors = [];
  raw.forEach((r, i) => {
    const o = {};
    Object.entries(r).forEach(([k, v]) => {
      const f = Object.keys(ALIASES).find((a) => ALIASES[a].includes(norm(k)));
      if (f) o[f] = v;
    });
    const line = i + 2;
    const g = String(o.group_name ?? "").trim(), s = String(o.site_name ?? "").trim(), u = String(o.user_code ?? "").trim();
    if (!g && !s && !u) return;
    if (!g || !s || !u) return errors.push(`Row ${line}: Group, Site and User ID are required`);
    const amtRaw = String(o.amount ?? "").replace(/[₹,\s]/g, "");
    if (amtRaw.toUpperCase() === "BAL") return;
    const amount = amtRaw === "" ? null : Number(amtRaw);
    if (amount !== null && isNaN(amount)) return errors.push(`Row ${line}: invalid amount`);
    let d = toISO(o.entry_date);
    if (d === "invalid") return errors.push(`Row ${line}: invalid date (use DD-MM-YYYY)`);
    if (amount !== null && !d) d = defaultDate;
    rows.push({ key: `${line}`, group_name: g, site_name: s, user_code: u, amount, entry_date: amount !== null ? d : null });
  });
  return { rows, errors };
};

export const downloadTemplate = () => {
  const ws = XLSX.utils.aoa_to_sheet([HEADERS, ["Group A", "Site 1", "U100", "12-06-2026", 1500], ["Group A", "Site 2", "U101", "12-06-2026", 2500]]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Import");
  XLSX.writeFile(wb, "import-template.xlsx");
};
